import { render, staticRenderFns } from "./RollDetail.vue?vue&type=template&id=aca8e630&scoped=true&"
import script from "./RollDetail.vue?vue&type=script&lang=js&"
export * from "./RollDetail.vue?vue&type=script&lang=js&"
import style0 from "./RollDetail.vue?vue&type=style&index=0&id=aca8e630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca8e630",
  null
  
)

export default component.exports